<ul class="navbar-nav ml-auto">
    <li>
        <div class="dropdown drp-user" ngbDropdown placement="auto">
            <a href="javascript:" ngbDropdownToggle style="width: unset !important;">
              {{user | uppercase}}
              <i class="fa fa-user text-white ml-2"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right profile-notification" ngbDropdownMenu>
                <div class="pro-head">
                    <!-- <div class="row">
                        <div class="col-2">
                            <img src="assets/img/no-user.png" class="img-radius  bg-light mb-2  " alt="User-Profile-Image">
                        </div>
                        <div class="col-8 text-center">
                            <h5 class="text-white   ">{{user | uppercase}}</h5>
                        </div>
                    </div> -->
                    <div class="col-12">
                        <button class="btn btn-block btn-danger" (click)="cerrarSesion()">Cerrar Sesión</button>
                    </div>

                </div>
       
            </div>
        </div>
    </li>
</ul>
